import { z } from 'zod';

// Information Item Schema
export const informationItemSchema = z.object({
  informationId: z.number(),
  title: z.string(),
  summary: z.string().nullable(),
  releaseDate: z.string(),
  body: z.string(),
});

// Information List Response Schema
export const informationListResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  status: z.string(),
  data: z.object({
    items: z.array(informationItemSchema),
    totalItems: z.number(),
    page: z.number(),
    pageSize: z.number(),
    totalPages: z.number(),
  }),
});

// Types
export type InformationItem = z.infer<typeof informationItemSchema>;
export type InformationListResponse = z.infer<typeof informationListResponseSchema>;
export type InformationData = z.infer<typeof informationListResponseSchema>['data'];
